module.exports = __webpack_public_path__ + "assets/3b6c045c2772bcbf322dfa47535d90b3.mp4";